<template>
  <div class="container-fluid m-0 p-0" id="TicketCP">
    <BnpGrid :key="tablekey" :Noresposive="false" :Sortable="true" :Selectable="false" :action="true" :propsRows="Rows" :propsColumn="propsColumn" :NoRowNum="true" :ticketManager="true" :hasRowNum="true">
      <template slot="userNameFam" slot-scope="props">
        <SearchableCombo
          v-if="$store.state.renderComponentCombo"
          :grp="0"
          :code="null"
          @ResultCombo="GetResulUserId"
          :rownumintable="3"
          :defaultvalue="props.props.tblUserId"
          :action="'TblCrmCombo/GetUserDatails'"
          :method="'POST'"
          :idinput="'UserId' + props.props.id"
          :keyItem="'UserId' + props.props.id"
        >
        </SearchableCombo>
      </template>
      <template slot="nameGrp45" slot-scope="props">
        <SearchableCombo
          v-if="$store.state.renderComponentCombo"
          :edit="false"
          :grp="45"
          :code="null"
          @ResultCombo="GetResultGrp45"
          :rownumintable="3"
          :defaultvalue="props.props.tblComboGrpId45"
          :action="'TblCrmCombo/GetComboById'"
          :method="'POST'"
          :idinput="'Grp45Id' + props.props.id"
          :keyItem="'Grp45Id' + props.props.id"
        >
        </SearchableCombo>
      </template>
      <template slot="nameGrp41" slot-scope="props">
        <SearchableCombo
          v-if="$store.state.renderComponentCombo"
          :edit="false"
          :noIcone="true"
          :grp="41"
          :code="null"
          @ResultCombo="GetResultGrp41"
          :rownumintable="3"
          :defaultvalue="props.props.tblComboGrpId41"
          :action="'TblCrmCombo/GetComboById'"
          :ClassProps="'d-none'"
          :method="'POST'"
          :idinput="'Grp41Id' + props.props.id"
          :keyItem="'Grp41Id' + props.props.id"
        >
        </SearchableCombo>
        <!-- <a :data-title="props.props.nameGrp41" class="input-drop-down" @click="ClickCombo('Grp41Id' + props.props.id)">
              <i class="fa fa-circle input-drop-down" :style="{ color: Vaziat(props.props.tblComboGrpId41) }"></i>
            </a> -->
        <a :data-title="props.props.nameGrp41" :name="'Grp41Id' + props.props.id" class="input-drop-down" @click="ClickCombo('Grp41Id' + props.props.id)">
          <i class="input-drop-down" :name="'Grp41Id' + props.props.id" :style="{ color: Vaziat(props.props.tblComboGrpId41) }"> {{ props.props.nameGrp41 }}</i>
        </a>
      </template>
      <template slot="score" slot-scope="props">
        <!-- <star-rating :show-rating="false" :star-size="15" :inline="true" v-model="props.props.score" :read-only="true"> </star-rating> -->
        <a href="javascript:;" class="mr-2" @click="GetuserTicket(props.props.id)">
          <i class="fas fa-star text-warning"></i>
        </a>
      </template>
      <template slot="customerName" slot-scope="props">
        <a
          v-if="props.props.InsertCustCode > 0"
          href="javascript:;"
          @click="$FindeCustomerById('DetailCustomer',props.props.CId,false,$event)" 
          @click.middle="$FindeCustomerById('DetailCustomer',props.props.CId,false,$event)"
          style="white-space: nowrap; cursor: pointer !important"
          data-toggle="tooltip"
          data-placement="top"
          :data-title="props.props.customerName"
        >
          {{ props.props.customerName.slice(0, 30) + (props.props.customerName.length > 30 ? '...' : '') }}
        </a>
        <SearchableCombo
          v-if="$store.state.renderComponentCombo && props.props.insertCustCode <= 0"
          :edit="false"
          :grp="null"
          :code="null"
          @ResultCombo="ChangeCustomer"
          :rownumintable="3"
          :defaultvalue="props.props.tblCustomerId"
          :action="'TblCrmCombo/GetCostomerProduct'"
          :method="'POST'"
          :idinput="'ChangeCustomer' + props.props.id"
          :keyItem="'ChangeCustomer' + props.props.id"
        >
        </SearchableCombo>
      </template>
      <template slot="title" slot-scope="props">
        <a
          @click="goToChatRoom(props.props.tlChatRoomId, props.props.tblUserId, props.props.id, props.props.tblComboGrpId41, props.props.tblDepartmentId, props.props.customerName, props.props.customerCode, props.props.tblCustomerId, props.props)"
          class="ChatroomVisted"
          :href="baseUrl + '/app/ChatRoom#' + props.props.id"
          style="white-space: nowrap;  !important"
          data-toggle="tooltip"
          data-placement="top"
          :data-title="props.props.title"
          >{{ props.props.title.slice(0, 30) + (props.props.title.length > 30 ? '...' : '') }}</a
        >
      </template>
      <template slot="id" slot-scope="props">
        <a
          class="ChatroomVisted"
          :href="baseUrl + '/app/ChatRoom#' + props.props.id"
          @click="goToChatRoom(props.props.tblChatRoomId, props.props.tblUserId, props.props.id, props.props.tblComboGrpId41, props.props.tblDepartmentId, props.props.customerName, props.props.customerCode, props.props.tblCustomerId, props.props)"
          >{{ props.props.id }}</a
        >
      </template>
      <template slot="action-slot" slot-scope="props">
        <div class="row">
          <div class="text-center col-3">
            <a href="javascript:;" class="mr-1" @click="goToChatRoom(props.props.tblChatRoomId, props.props.tblUserId, props.props.id, props.props.tblComboGrpId41, props.props.tblDepartmentId, props.props.customerName, props.props.customerCode, props.props.tblCustomerId, props.props)">
              <h6><span class="fa fa-comments-o hover-info"></span></h6>
            </a>
          </div>
          <div class="text-center col-3">
                <a href="javascript:;" class="mr-1" @click="GetCountTicketResponse(props.props.id)">
                  <h6><span class="fas fa-calculator" data-title="تعداد پاسخ"></span></h6>
                </a>
              </div>
          <div class="text-center col-3">
            <a href="javascript:;" class="mr-1" @click="OnDetail(props.props)">
              <h6><span class="fas fa-info text-info hover-danger"></span></h6>
            </a>
          </div>
          
        </div>
      </template>
    </BnpGrid>
  </div>
</template>
<script>
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'

export default {
  props: ['Rows'],
  components: { BnpGrid, SearchableCombo },
  data() {
    return {
      baseUrl: '',

      propsColumn: [],
      DataAxoisRiz: {
        ArryfildValue: {
          SoftwareId: 2,
          UserId: 1,
          FormName: 'frmTickets',
          ShowView: 0,
        },
        Method: 'post',
        Action: 'ReadGridColumns',
      },
      tablekey: 1520,
    }
  },
  created() {
    this.$GetColumns(this.DataAxoisRiz, true)
      .then((data) => {
        this.propsColumn = data
        this.propsColumn.forEach((x) => {
          x.name = x.name.charAt(0).toLowerCase() + x.name.slice(1)
        })
      })
      .finally(() => {
        this.tablekey++
      })
  },
  methods: {
    GetCountTicketResponse(id){
      this.$PostData_new('get', 'Ticket/GetCountTicketResponse/' + id).then((response) => {
        let message = "تعداد پاسخ در تیکت " + id + "#:  " + response +" عدد "
        this.$toasted.info(message, {
            action: {
              text: "",
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              },
            },
          });
      })
    },
    ChangeCustomer(data) {
      if (data.id != null && !data.IsDefault) {
        var DataAxios = { Method: 'POST', Action: 'Ticket/ChangeCustomer', ArryfildValue: { TkcetId: Number(data.key.replace('ChangeCustomer', '')), tblCustomerId: data.id, tblusergrp: this.$session.get('UserInfo').tblUserGrpId } }
        this.$PostData(DataAxios).then((result) => {
          if (result.status == 'success') {
            this.$toasted.success(result.text, { duration: 2000 })
          } else {
            this.$toasted.error(result.text, { duration: 2000 })
          }
          this.Search()
        })
      }
    },
    Vaziat(id) {
      var colors = ['#5CB0FF', '#eddd85', '#FDA700', '#fd397a', '#21AE89', '#5578eb', '#657685', '#b7d91e']
      var values = ['1798', '1797', '1796', '1795', '1794', '1793', '1792', '1791', '1841']
      var num = values.indexOf(id + '')
      return colors[num]
    },
    OnDetail(row) {
      var DataAxios = {
        Action: 'Ticket/GetTicketLog',
        Method: 'Get',
        ArryfildValue: {
          Id: row.Id,
        },
      }
      this.$GetData_Header(DataAxios)
        .then((response) => {
          this.rows = response
        })
        .finally(() => {
          this.$bvModal.show('modal-LogTicket')
          this.$store.state.renderComponentGridModal = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGridModal = true
          })
        })
    },
    GetResulUserId(data) {
      if (data.id != null && !data.IsDefault) {
        var index = Number(data.key.replace('UserId', ''))
        this.DataAxios.TblUserIdTask = data.id
        if (data.id.length < 1) {
          return
        }
        let ticketFind = this.propsRows.find((x) => x.Id == index)

        if (ticketFind.TblComboGrpId45 == null || ticketFind.TblComboGrpId45 == '') {
          this.$mySweetDefaultTost('', 'ابتدا نوع تیکت را مشخص نمایید', 'warning', 3500)
          this.$store.state.renderComponentGrid = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true
          })
          return
        }
        let departmentId = ticketFind.TblDepartmentId
        let Dataaxios = {
          Action: 'Ticket/CheckDepartmentRefrenceTicket',
          Method: 'Post',
          ArryfildValue: {
            userId: this.DataAxios.TblUserIdTask,
            departmentId: departmentId,
          },
        }
        this.$PostData(Dataaxios).then((res) => {
          if (res.isSuccess == true) {
            this.signalRTicketConnection
              .invoke('ReferenceTicket', String(index), String(this.DataAxios.TblUserIdTask), String(this.$session.get('UserInfo').tblUserGrpId))
              .then((res) => {
                this.$mySweetDefaultTost('عملیات موفق', 'تیکت با موفقیت ارجاع شد', 'success', 2000)
                var ticket = this.propsRows.find((element) => element.Id == index)
                if (ticket != undefined) {
                  ticket.TblUserId = data.id
                }
                // this.Search()
                this.mergeTickesId = []
              })
              .catch((error) => {
                this.$mySweetDefaultTost('عملیات ناموفق', 'خطایی رخ داد', 'error', 2000)
                console.error('CATCH', error)
              })
          } else {
            this.showModalRefrence = true
            this.changeDepartmentRequest.ticketId = index
            this.changeDepartmentRequest.userIdTask = this.DataAxios.TblUserIdTask
            this.checkRefrenceTicketResult = res
          }
        })
      }
    },
    goToChatRoom(chatRoomId, ticketManagerTblUserId, ticketId, tblComboIdTicketStatus, departmentId, customerName, customerCode, tblCustomerId, ticket) {
      this.$router.push({
        name: 'ChatRoom',
        params: {
          chatRoomId: chatRoomId,
          ticketManagerTblUserId: ticketManagerTblUserId,
          ticketId: ticketId,
          tblComboIdTicketStatus: tblComboIdTicketStatus,
          departmentId: departmentId,
          customerName: customerName,
          customerCode: customerCode,
          tblCustomerId: tblCustomerId,
          tblUserGrpIdInsertTicket: ticket.TblUserGrpIdInsert,
          ticket: ticket,
          tblComboGrpId45: ticket.TblComboGrpId45,
          tblComboGrpId42: ticket.TblComboGrpId42,
        },
      })
    },
    GetResultGrp45(data) {
      if (data.id != null && !data.IsDefault) {
        this.DataAxios.tblComboGrpId45 = data.id
        var index = Number(data.key.replace('Grp45Id', ''))
        let request = {
          TicketId: index,
          TblComboGrpId45: this.DataAxios.tblComboGrpId45,
        }
        request = JSON.stringify(request)

        this.signalRTicketConnection
          .invoke('Grp45Ticket', request)
          .then((res) => {
            this.$toasted.success('توع تیکت با موفقیت نغییر یافت', {
              action: {
                text: 'بستن',
                onClick: (e, toastObject) => {
                  toastObject.goAway(0)
                },
              },
            })
            let findTicket = this.propsRows.find((x) => x.Id == index)
            findTicket.TblComboGrpId45 = this.DataAxios.tblComboGrpId45
            // this.Search()
            // this.mergeTickesId = []
          })
          .catch((error) => {
            this.$mySweetDefaultTost('عملیات ناموفق', 'خطایی رخ داد', 'error', 2000)
            console.error('CATCH', error)
          })
      }
    },
    GetResultGrp41(data) {
      if (data.id != null && !data.IsDefault) {
        this.DataAxios.tblComboGrpId41 = data.id
        var index = Number(data.key.replace('Grp41Id', ''))
        var record = this.propsRows.find((element) => element.Id == index)

        this.signalRChatConnection
          .invoke('ChangeStatus', String(index), data.id + '', String(this.$session.get('UserInfo').tblUserGrpId), record.TblDepartmentId + '', record.TblChatRoomId + '')
          .then((res) => {
            this.$toasted.success('وضعیت تیکت با موفقیت نغییر یافت', {
              action: {
                text: 'بستن',
                onClick: (e, toastObject) => {
                  toastObject.goAway(0)
                },
              },
            })
            this.Search()
            this.mergeTickesId = []
          })
          .catch((error) => {
            this.$mySweetDefaultTost('عملیات ناموفق', 'خطایی رخ داد', 'error', 2000)
            console.error('CATCH', error)
          })
      }
    },
    GetResulTblCostomer(data) {
      this.request.TblCustomerId = data.id
    },
  },
  mounted() {
    this.baseUrl = window.location.origin
  },
}
</script>
<style>
#TicketCP table input {
  font-size: small !important;
}

#TicketCP table {
  font-size: smaller !important;
}

.ChatroomVisted:visited {
  color: gray !important;
}
</style>
